import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class MovecustomerstructureService {

	private apiUrl = globalConst.baseAPI;  // URL para web api
	
	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	getAccountClient(token, id, name, doc, nickname, rep, ctc, gc, dc, orderby, sort, page) {

		var params = {
			CodigoPrincipal: id,
			Nome: name,
			Documento: doc,
			Apelido: nickname,
			Representante: rep,
			CTC: ctc,
			GC: gc,
			DC: dc,
			Ativo: true
		};

		page = page * globalConst.paginationSkip100;

		return this.http
			.post(this.apiUrl + "/accounts/v1/searchbycomlstruc?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip100+"&$skip=" + page + "", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCTC(token) {

		return this.http
		.get(this.apiUrl + "commercialstructure/v1/getcommercialstructurebypapel/C?$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	searchRepresentante(token, nome) {

		return this.http
		.get(this.apiUrl + "representative/v1/getrepresentative?$orderby=Nome&$filter=substringof('" + nome.toLowerCase() + "',tolower(Nome))", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});

	}

	setCustomerStrucuture(token, obj) {

		return this.http
		.put(this.apiUrl + "accounts/v1/updatecustomerstructure/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	setCustomerRep(token, obj) {

		return this.http
		.put(this.apiUrl + "accounts/v1/updatecustomerrep/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}
	
}



// WEBPACK FOOTER //
// ./src/app/movecustomerstructure/service/movecustomerstructure/movecustomerstructure.service.ts